module.exports = __webpack_public_path__ + "media/src/images/demo-506ce35f9fd1b40b27ecb742aa3d04b2.png";